var _mask, _mask2, _mask3, _mask4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagAuIcon = function SvgFlagAuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "flagAUIcon_svg__a",
    width: 16,
    height: 12,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2h16v12H0z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "flagAUIcon_svg__b",
    width: 16,
    height: 12,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 2v12h16V2z",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "flagAUIcon_svg__c",
    width: 9,
    height: 7,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2h9v7H0z"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "flagAUIcon_svg__d",
    width: 11,
    height: 9,
    x: -1,
    y: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1 1h11v9H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.992 2h-1v3H0v1h3.992v3h1V6H9V5H4.992z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagAUIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    fillRule: "evenodd",
    d: "M0 2v12h16V2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagAUIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2b409a",
    d: "M0 2h9v7H0z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagAUIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    d: "m-1.002 8.5 1.98.869 8.067-6.425 1.045-1.29-2.118-.29-3.29 2.768-2.649 1.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    d: "m-.73 9.108 1.008.505 9.437-8.08H8.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    d: "m10.002 8.5-1.98.869-8.067-6.425-1.044-1.29 2.117-.29 3.29 2.768 2.649 1.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    d: "m9.935 8.937-1.01.504-4.017-3.46-1.192-.386-4.906-3.937H.227L5.13 5.502l1.303.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    fillRule: "evenodd",
    d: "M4.992 2h-1v3H0v1h3.992v3h1V6H9V5H4.992z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagAUIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    d: "M3.992 2v-.75h-.75V2zm1 0h.75v-.75h-.75zm-1 3v.75h.75V5zM0 5v-.75h-.75V5zm0 1h-.75v.75H0zm3.992 0h.75v-.75h-.75zm0 3h-.75v.75h.75zm1 0v.75h.75V9zm0-3v-.75h-.75V6zM9 6v.75h.75V6zm0-1h.75v-.75H9zM4.992 5h-.75v.75h.75zm-1-2.25h1v-1.5h-1zM4.742 5V2h-1.5v3zM0 5.75h3.992v-1.5H0zM.75 6V5h-1.5v1zm3.242-.75H0v1.5h3.992zM4.742 9V6h-1.5v3zm.25-.75h-1v1.5h1zM4.242 6v3h1.5V6zM9 5.25H4.992v1.5H9zM8.25 5v1h1.5V5zm-3.258.75H9v-1.5H4.992zM4.242 2v3h1.5V2z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    d: "m4.5 12.25-.65.601.064-.883-.876-.134.73-.5-.44-.77.847.26L4.5 10l.325.824.848-.26-.442.77.731.5-.876.134.065.883zM11 8.5l-.434.4.043-.588-.584-.09.488-.333-.295-.513.565.173L11 7l.217.55.565-.173-.294.512.487.333-.584.09.043.589zm1-4-.434.401.043-.59-.584-.088.488-.334-.295-.512.565.173L12 3l.217.55.565-.173-.294.512.487.334-.584.089.043.589zm2.5 2-.434.401.043-.59-.584-.088.488-.334-.295-.512.565.173L14.5 5l.217.55.565-.173-.294.512.487.334-.584.089.043.589zm-2 6.5-.434.401.043-.59-.584-.089.488-.333-.295-.512.565.172.217-.549.217.55.565-.174-.294.513.487.334-.584.089.043.589zm1.75-3.875-.44.232.083-.491-.356-.348.492-.071.22-.447.221.447.493.071-.356.348.084.49z"
  }))));
};
export { SvgFlagAuIcon as ReactComponent };